import { render, staticRenderFns } from "./dgoodsInfo.vue?vue&type=template&id=04183de2&scoped=true&"
import script from "./dgoodsInfo.vue?vue&type=script&lang=js&"
export * from "./dgoodsInfo.vue?vue&type=script&lang=js&"
import style0 from "./dgoodsInfo.vue?vue&type=style&index=0&id=04183de2&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04183de2",
  null
  
)

export default component.exports